'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceStorage = function DeviceStorage(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z' })
  );
};
DeviceStorage = (0, _pure2.default)(DeviceStorage);
DeviceStorage.displayName = 'DeviceStorage';
DeviceStorage.muiName = 'SvgIcon';

exports.default = DeviceStorage;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/device/storage.js
// module id = 1350
// module chunks = 0